export const defaultColors = {
  header: '#199ED8',
  headerSecondaryNav: '#199ED8',
  headerNavSelected: '#199ED8',
  headerSecondaryNavSelected: '#199ED8',
  headerNavHover: '#199ED8',
  headerSecondaryNavHover: '#199ED8',
  headerDropdown: '#199ED8',
  headerSecondaryNavDropdown: '#199ED8',
  headerDropdownHover: '#FFFFFF',
  headerSecondaryNavDropdownHover: '#FFFFFF',
  tableSelection: '#009DDC',
  dropdownHover: '#009DDC',
  actionBtn: '#169BD5',
  optionBtn: '#FF00FF',
  inlineBtn: '#800080',
  cancelBtn: '#FF4455',
  dangerBtn: '#FF0000',
  successBtn: '#00FF00',
  successNt: '#00FF00',
  dangerNt: '#FF0000',
  infoNt: '#FFFF00',
  loadingNt: '#ADD8E6',
  warningNt: '#FFFF00',
  dropdown: 'pink',
};
